import BaseTableNew from 'components/atoms/base-table/new';
import { useClinicCareManagers } from 'infrastructure/hooks/clinic/use-clinic-care-managers';
import * as clinicCareManagers from 'constants/clinicCareManagers';
import useUser from 'utils/useUser';

import { useCareManagersCols } from './cols';
import s from './styles.module.scss';

import type {
  IClinicCareManager,
  IClinicCareManagerLite,
} from 'infrastructure/interfaces';

interface IProps {
  items?: number;
  clinicGuid?: string;
  page: number;
  setPage: (num: number) => void;
  isEditable?: boolean;
  customItems?: IClinicCareManagerLite[];
}

const CareManagersTable = ({
  items,
  clinicGuid,
  page,
  setPage,
  isEditable,
  customItems,
}: IProps) => {
  const user = useUser();
  const disableRefs = !user.isAgencyDoctor;
  const { cols } = useCareManagersCols({ disableRefs, isEditable });
  let pageSize = 0;
  if (items) {
    pageSize = isEditable
      ? 1000
      : clinicCareManagers.CLINIC_CARE_MANAGERS_TABLE_ITEMS_PER_PAGE;
  }
  const { careManagers, loading } = useClinicCareManagers({
    items: pageSize,
    clinicGuid,
    page,
  });

  return (
    <BaseTableNew
      bordered
      rowClassName={s['table-row']}
      loading={loading}
      items={
        isEditable && customItems?.length
          ? [...(customItems as IClinicCareManager[])]
          : careManagers?.items || []
      }
      pagination={{
        current: page ?? 1,
        pageSize,
        total: careManagers?.count ?? 0,
      }}
      onChangePage={setPage}
      columns={cols}
    />
  );
};
export default CareManagersTable;
